import React from "react";
import { Trans } from "@lingui/macro";
import SEO from "components/Common/SEO";

import Footer from "components/Footer/Footer";
import { getPageTitle } from "lib/legacy";

import "./Ecosystem.css";
import ExternalLink from "components/ExternalLink/ExternalLink";
import { ARBITRUM, BSC } from "config/chains";
import { t } from "@lingui/macro";
import { getIcon } from "config/icons";
import PageTitle from "components/PageTitle/PageTitle";

const NETWORK_ICONS = {
  [ARBITRUM]: getIcon(ARBITRUM, "network"),
  [BSC]: getIcon(BSC, "network"),
};

const NETWORK_ICON_ALTS = {
  [ARBITRUM]: "Ronin Icon",
  [BSC]: "Bsc Icon",
};

export default function Ecosystem() {
  const moneyPages = [
    {
      title: "MONEY Governance",
      link: "https://gov.money.io/",
      linkLabel: "gov.money.io",
      about: t`MONEY Governance Page`,
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Stats",
      link: "https://stats.money.io/",
      linkLabel: "stats.money.io",
      about: t`MONEY Stats Page`,
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Proposals",
      link: "https://snapshot.org/#/money.eth",
      linkLabel: "snapshot.org",
      about: t`MONEY Proposals Voting page`,
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Announcements",
      link: "https://t.me/MONEY_Announcements",
      linkLabel: "t.me",
      about: t`MONEY Announcements and Updates`,
      chainIds: [ARBITRUM, BSC],
    },
  ];

  const communityProjects = [
    {
      title: "MONEY Blueberry Club",
      link: "https://www.blueberry.club/",
      linkLabel: "blueberry.club",
      about: t`MONEY Blueberry NFTs`,
      creatorLabel: "@xm_gbc",
      creatorLink: "https://t.me/xm_gbc",
      chainIds: [ARBITRUM],
    },
    {
      title: "MONEY Leaderboard",
      link: "https://www.money.house/",
      linkLabel: "money.house",
      about: t`Leaderboard for MONEY traders`,
      creatorLabel: "@Itburnz",
      creatorLink: "https://t.me/Itburnz",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Positions Bot",
      link: "https://t.me/MONEYPositions",
      linkLabel: "t.me",
      about: t`Telegram bot for MONEY position updates`,
      creatorLabel: "@zhongfu",
      creatorLink: "https://t.me/zhongfu",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "Blueberry Pulse",
      link: "https://blueberrypulse.substack.com/",
      linkLabel: "substack.com",
      about: t`MONEY Weekly Updates`,
      creatorLabel: "@puroscohiba",
      creatorLink: "https://t.me/puroscohiba",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Yield Simulator",
      link: "https://money.defisims.com/",
      linkLabel: "defisims.com",
      about: t`Yield simulator for MONEY`,
      creatorLabel: "@kyzoeth",
      creatorLink: "https://twitter.com/kyzoeth",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Returns Calculator",
      link: "https://docs.google.com/spreadsheets/u/4/d/1mQZlztz_NpTg5qQiYIzc_Ls1OTLfMOUtmEQN-WW8jj4/copy",
      linkLabel: "docs.google.com",
      about: t`Returns calculator for MONEY and MLP`,
      creatorLabel: "@AStoicTrader1",
      creatorLink: "https://twitter.com/AStoicTrader1",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Trading Stats",
      link: "https://t.me/MONEYTradingStats",
      linkLabel: "t.me",
      about: t`Telegram bot for Open Interest on MONEY`,
      creatorLabel: "@SniperMonke01",
      creatorLink: "https://twitter.com/SniperMonke01",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Staking Bot",
      link: "https://t.me/MONEY_Staking_bot",
      linkLabel: "t.me",
      about: t`MONEY staking rewards updates and insights`,
      creatorLabel: "@MONEY_Staking_bot",
      creatorLink: "https://twitter.com/MONEY_Staking_bot",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Staking Calculator",
      link: "https://moneystaking.com",
      linkLabel: "moneystaking.com",
      about: t`MONEY staking calculator`,
      creatorLabel: "@n1njawtf",
      creatorLink: "https://t.me/n1njawtf",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Hedging Simulator",
      link: "https://www.moneyhedge.com/",
      linkLabel: "moneyhedge.com",
      about: t`Simulate your hedge strategy`,
      creatorLabel: "@kyzoeth",
      creatorLink: "https://twitter.com/kyzoeth",
      chainIds: [ARBITRUM],
    },
    {
      title: "MONEY Swaps",
      link: "https://t.me/MONEYSwaps",
      linkLabel: "t.me",
      about: t`Telegram bot for MONEY Swaps monitoring`,
      creatorLabel: "@snipermonke01",
      creatorLink: "https://twitter.com/snipermonke01",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Position Calculator",
      link: "https://docs.google.com/spreadsheets/d/1OKCeRGU7l-xGx33-siBw_l8x7vP97y4KKKjA2x5LqhQ/edit#gid=0",
      linkLabel: "docs.google.com",
      about: t`Spreadsheet for position calculations`,
      creatorLabel: "@barryfried1",
      creatorLink: "https://twitter.com/barryfried1",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "SNTL esMONEY Market",
      link: "https://sntl.market/",
      linkLabel: "sntl.market",
      about: t`esMONEY OTC Market`,
      creatorLabel: "@sntlai",
      creatorLink: "https://twitter.com/sntlai",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "Copin",
      link: "https://app.copin.io",
      linkLabel: "copin.io",
      about: t`Explore, analyze, and copy on-chain traders`,
      creatorLabel: ["@0xanol", "@tungle_eth"],
      creatorLink: ["https://twitter.com/0xanol", "https://twitter.com/tungle_eth"],
      chainIds: [ARBITRUM],
    },
  ];

  const dashboardProjects = [
    {
      title: "MONEY Referrals Dashboard",
      link: "https://www.moneyreferrals.com/",
      linkLabel: "moneyreferrals.com",
      about: t`Dashboard for MONEY referral stats`,
      creatorLabel: "@kyzoeth",
      creatorLink: "https://twitter.com/kyzoeth",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Terminal",
      link: "https://moneyterminal.com",
      linkLabel: "moneyterminal.com",
      about: t`MONEY explorer for stats and traders`,
      creatorLabel: "@vipineth",
      creatorLink: "https://t.me/vipineth",
      chainIds: [ARBITRUM],
    },
    {
      title: "MONEY Analytics",
      link: "https://moneystats.info/",
      linkLabel: "moneystats.info",
      about: t`Financial reports and protocol analytics`,
      creatorLabel: "@sliux",
      creatorLink: "https://twitter.com/sliux",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "TokenTerminal",
      link: "https://tokenterminal.com/terminal/projects/money",
      linkLabel: "tokenterminal.com",
      about: t`MONEY fundamentals`,
      creatorLabel: "@tokenterminal",
      creatorLink: "https://twitter.com/tokenterminal",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "CryptoFees",
      link: "https://cryptofees.info",
      linkLabel: "cryptofees.info",
      about: t`Fees generated by MONEY`,
      creatorLabel: "@CryptoFeesInfo",
      creatorLink: "https://twitter.com/CryptoFeesInfo",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "Shogun Dashboard (Dune Ronin)",
      link: "https://dune.com/shogun/money-analytics-arbitrum",
      linkLabel: "dune.com",
      about: t`Protocol analytics`,
      creatorLabel: "@JamesCliffyz",
      creatorLink: "https://twitter.com/JamesCliffyz",
      chainIds: [ARBITRUM],
    },
    {
      title: "Shogun Dashboard (Dune Bsc)",
      link: "https://dune.com/shogun/money-analytics-bsc",
      linkLabel: "dune.com",
      about: t`Protocol analytics`,
      creatorLabel: "@JamesCliffyz",
      creatorLink: "https://twitter.com/JamesCliffyz",
      chainIds: [BSC],
    },
    {
      title: "MONEY Perpetuals Data",
      link: "https://app.laevitas.ch/altsderivs/MONEY/perpetualswaps",
      linkLabel: "laevitas.ch",
      about: t`MONEY Perpetuals Data`,
      creatorLabel: "@laevitas1",
      creatorLink: "https://twitter.com/laevitas1",
      chainIds: [ARBITRUM],
    },
    {
      title: "MONEY Blueberry Leaderboard",
      link: "https://www.blueberryboard.com",
      linkLabel: "blueberryboard.com",
      about: t`GBC NFTs APR tracker and rewards`,
      creatorLabel: "@kyzoeth",
      creatorLink: "https://twitter.com/kyzoeth",
      chainIds: [ARBITRUM],
    },
    {
      title: "MONEY Open Trades Ranking and Stats",
      link: "https://dune.com/HanSolar/money-open-trade-ranking-and-stats",
      linkLabel: "dune.com",
      about: t`Open trades ranking and stats`,
      creatorLabel: "@hansolar21",
      creatorLink: "https://twitter.com/hansolar21",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Everything Dashboard",
      link: "https://dune.com/moneytrader/money-dashboard-insights",
      linkLabel: "dune.com",
      about: t`Overall protocol analytics`,
      creatorLabel: "@moneytrader",
      creatorLink: "https://twitter.com/moneytrader",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "Staking Rewards Calculator",
      link: "https://www.stakingrewards.com/earn/money/",
      linkLabel: "stakingrewards.com",
      about: t`MONEY staking calculator and guide`,
      creatorLabel: "@stakingrewards",
      creatorLink: "https://twitter.com/stakingrewards",
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "MONEY Risk Monitoring",
      link: "https://community.chaoslabs.xyz/money-arbitrum/ccar-perps/overview",
      linkLabel: "chaoslabs.xyz",
      about: t`Protocol risk explorer and stats`,
      creatorLabel: "@chaos_labs",
      creatorLink: "https://twitter.com/chaos_labs",
      chainIds: [ARBITRUM, BSC],
    },
  ];

  const integrations = [
    {
      title: "DeBank",
      link: "debank.com",
      linkLabe: "debank.com",
      about: t`DeFi Portfolio Tracker`,

      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "Defi Llama",
      link: "https://defillama.com",
      linkLabel: "defillama.com",
      about: t`Decentralized Finance Dashboard`,

      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "Dopex",
      link: "https://dopex.io",
      linkLabel: "dopex.io",
      about: t`Decentralized Options Protocol`,
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "Jones DAO",
      link: "https://jonesdao.io",
      linkLabel: "jonesdao.io",
      about: t`Decentralized Options Strategies`,

      chainIds: [ARBITRUM],
    },
    {
      title: "Yield Yak Optimizer",
      link: "https://yieldyak.com/",
      linkLabel: "yieldyak.com",
      about: t`Yield Optimizer on Bsc`,

      chainIds: [BSC],
    },
    {
      title: "Vovo Finance",
      link: "https://vovo.finance/",
      linkLabel: "vovo.finance",
      about: t`Structured Products`,

      chainIds: [ARBITRUM],
    },
    {
      title: "Stabilize Protocol",
      link: "https://www.stabilize.finance/",
      linkLabel: "stabilize.finance",
      about: t`Yield Vaults`,

      chainIds: [ARBITRUM],
    },
    {
      title: "DODO",
      link: "https://dodoex.io/",
      linkLabel: "dodoex.io",
      about: t`Decentralized Trading Protocol`,

      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "Open Ocean",
      link: "https://openocean.finance/",
      linkLabel: "openocean.finance",
      about: t`DEX Aggregator`,

      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "Paraswap",
      link: "https://www.paraswap.io/",
      linkLabel: "paraswap.io",
      about: t`DEX Aggregator`,

      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "1inch",
      link: "https://1inch.io/",
      linkLabel: "1inch.io",
      about: t`DEX Aggregator`,

      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "Firebird Finance",
      link: "https://app.firebird.finance/swap",
      linkLabel: "firebird.finance",
      about: t`DEX Aggregator`,

      chainIds: [BSC],
    },
    {
      title: "Yield Yak Swap",
      link: "https://yieldyak.com/swap",
      linkLabel: "yieldyak.com",
      about: t`DEX Aggregator`,

      chainIds: [BSC],
    },
    {
      title: "Plutus",
      link: "https://plutusdao.io/vaults",
      linkLabel: "plutusdao.io",
      about: t`MLP autocompounding vaults`,

      chainIds: [ARBITRUM],
    },
    {
      title: "Beefy",
      link: "https://app.beefy.com/",
      linkLabel: "beefy.com",
      about: t`MLP and MONEY autocompounding vaults`,

      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "Pendle Finance",
      link: "https://app.pendle.finance/pro/markets",
      linkLabel: "pendle.finance",
      about: t`Yield Trading`,

      chainIds: [ARBITRUM],
    },
    {
      title: "ODOS",
      link: "https://app.odos.xyz/",
      linkLabel: "odos.xyz",
      about: t`DEX Aggregator`,

      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "Dolomite",
      link: "https://app.dolomite.io/balances",
      linkLabel: "dolomite.io",
      about: t`Decentralized Money Market`,

      chainIds: [ARBITRUM],
    },
    {
      title: "UniDex Leverage",
      link: "https://leverage.unidex.exchange/",
      linkLabel: "unidex.exchange",
      about: t`Leverage Trading Terminal`,
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "Symbiosis",
      link: "https://app.symbiosis.finance/",
      linkLabel: "symbiosis.finance",
      about: t`DEX Aggregator`,
      chainIds: [ARBITRUM, BSC],
    },
    {
      title: "0x",
      link: "https://explorer.0xprotocol.org/liquiditySources",
      linkLabel: "0xprotocol.org",
      about: t`DEX Aggregator`,
      chainIds: [ARBITRUM, BSC],
    },
  ];

  const telegramGroups = [
    {
      title: "MONEY",
      link: "https://t.me/MONEY_IO",
      linkLabel: "t.me",
      about: t`Telegram Group`,
    },
    {
      title: "MONEY (Chinese)",
      link: "https://t.me/moneych",
      linkLabel: "t.me",
      about: t`Telegram Group (Chinese)`,
    },
    {
      title: "MONEY (Portuguese)",
      link: "https://t.me/MONEY_Portuguese",
      linkLabel: "t.me",
      about: t`Telegram Group (Portuguese)`,
    },
    {
      title: "MONEY Trading Chat",
      link: "https://t.me/gambittradingchat",
      linkLabel: "t.me",
      about: t`MONEY community discussion`,
    },
  ];

  return (
    <SEO title={getPageTitle(t`Ecosystem Projects`)}>
      <div className="default-container page-layout">
        <div>
          <PageTitle
            showNetworkIcon={false}
            isTop
            title={t`MONEY Pages`}
            subtitle={t`MONEY ecosystem pages.`}
            qa="ecosystem-page"
          />
          <div className="Ecosystem-projects">
            {moneyPages.map((item) => {
              const linkLabel = item.linkLabel ? item.linkLabel : item.link;
              return (
                <div className="App-card" key={item.title}>
                  <div className="App-card-title">
                    {item.title}
                    <div className="App-card-title-icon">
                      {item.chainIds.map((network) => (
                        <img width="16" key={network} src={NETWORK_ICONS[network]} alt={NETWORK_ICON_ALTS[network]} />
                      ))}
                    </div>
                  </div>
                  <div className="App-card-divider"></div>
                  <div className="App-card-content">
                    <div className="App-card-row">
                      <div className="label">
                        <Trans>Link</Trans>
                      </div>
                      <div>
                        <ExternalLink href={item.link}>{linkLabel}</ExternalLink>
                      </div>
                    </div>
                    <div className="App-card-row">
                      <div className="label">
                        <Trans>About</Trans>
                      </div>
                      <div>{item.about}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <PageTitle
            showNetworkIcon={false}
            title={t`Community Projects`}
            subtitle={
              <Trans>
                Projects developed by the MONEY community. <br />
                Please exercise caution when interacting with any app, apps are fully maintained by community
                developers.
              </Trans>
            }
          />
          <div className="Ecosystem-projects">
            {communityProjects.map((item) => {
              const linkLabel = item.linkLabel ? item.linkLabel : item.link;
              return (
                <div className="App-card" key={item.title}>
                  <div className="App-card-title">
                    {item.title}
                    <div className="App-card-title-icon">
                      {item.chainIds.map((network) => (
                        <img width="16" key={network} src={NETWORK_ICONS[network]} alt={NETWORK_ICON_ALTS[network]} />
                      ))}
                    </div>
                  </div>
                  <div className="App-card-divider" />
                  <div className="App-card-content">
                    <div className="App-card-row">
                      <div className="label">
                        <Trans>Link</Trans>
                      </div>
                      <div>
                        <ExternalLink href={item.link}>{linkLabel}</ExternalLink>
                      </div>
                    </div>
                    <div className="App-card-row">
                      <div className="label">
                        <Trans>About</Trans>
                      </div>
                      <div>{item.about}</div>
                    </div>
                    <div className="App-card-row">
                      <div className="label">
                        <Trans>Creator</Trans>
                      </div>
                      <div>
                        {Array.isArray(item.creatorLabel) ? (
                          <div className="gap-right-xs">
                            {item.creatorLabel.map((label, index) => (
                              <ExternalLink key={label} href={item.creatorLink[index]}>
                                {label}
                              </ExternalLink>
                            ))}
                          </div>
                        ) : (
                          <ExternalLink href={item.creatorLink}>{item.creatorLabel}</ExternalLink>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <PageTitle showNetworkIcon={false} title={t`Dashboards`} subtitle={t`MONEY dashboards and analytics.`} />
          <div className="Ecosystem-projects">
            {dashboardProjects.map((item) => {
              const linkLabel = item.linkLabel ? item.linkLabel : item.link;
              return (
                <div className="App-card" key={item.title}>
                  <div className="App-card-title">
                    {item.title}
                    <div className="App-card-title-icon">
                      {item.chainIds.map((network) => (
                        <img width="16" key={network} src={NETWORK_ICONS[network]} alt={NETWORK_ICON_ALTS[network]} />
                      ))}
                    </div>
                  </div>

                  <div className="App-card-divider"></div>
                  <div className="App-card-content">
                    <div className="App-card-row">
                      <div className="label">
                        <Trans>Link</Trans>
                      </div>
                      <div>
                        <ExternalLink href={item.link}>{linkLabel}</ExternalLink>
                      </div>
                    </div>
                    <div className="App-card-row">
                      <div className="label">
                        <Trans>About</Trans>
                      </div>
                      <div>{item.about}</div>
                    </div>
                    <div className="App-card-row">
                      <div className="label">
                        <Trans>Creator</Trans>
                      </div>
                      <div>
                        <ExternalLink href={item.creatorLink}>{item.creatorLabel}</ExternalLink>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <PageTitle
            showNetworkIcon={false}
            title={t`Partnerships and Integrations`}
            subtitle={t`Projects integrated with MONEY.`}
          />
          <div className="Ecosystem-projects">
            {integrations.map((item) => {
              const linkLabel = item.linkLabel ? item.linkLabel : item.link;
              return (
                <div key={item.title} className="App-card">
                  <div className="App-card-title">
                    {item.title}
                    <div className="App-card-title-icon">
                      {item.chainIds.map((network) => (
                        <img width="16" key={network} src={NETWORK_ICONS[network]} alt={NETWORK_ICON_ALTS[network]} />
                      ))}
                    </div>
                  </div>
                  <div className="App-card-divider"></div>
                  <div className="App-card-content">
                    <div className="App-card-row">
                      <div className="label">
                        <Trans>Link</Trans>
                      </div>
                      <div>
                        <ExternalLink href={item.link}>{linkLabel}</ExternalLink>
                      </div>
                    </div>
                    <div className="App-card-row">
                      <div className="label">
                        <Trans>About</Trans>
                      </div>
                      <div>{item.about}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="text-body-large mt-16">
            <Trans>
              MONEY uses TradingView to provide real-time cryptocurrency charts, so you can easily follow{" "}
              <ExternalLink href="https://www.tradingview.com/symbols/BTCUSD/">BTCUSD</ExternalLink> price in real-time,
              along with other currency pair rates. The interactive charts offer advanced tools and a user-friendly
              interface for easier market analysis and decision-making.
            </Trans>
          </div>
          <PageTitle showNetworkIcon={false} title={t`Telegram Groups`} subtitle={t`Community-led Telegram groups.`} />
          <div className="Ecosystem-projects">
            {telegramGroups.map((item) => {
              const linkLabel = item.linkLabel ? item.linkLabel : item.link;
              return (
                <div className="App-card" key={item.title}>
                  <div className="App-card-title">{item.title}</div>
                  <div className="App-card-divider"></div>
                  <div className="App-card-content">
                    <div className="App-card-row">
                      <div className="label">
                        <Trans>Link</Trans>
                      </div>
                      <div>
                        <ExternalLink href={item.link}>{linkLabel}</ExternalLink>
                      </div>
                    </div>
                    <div className="App-card-row">
                      <div className="label">
                        <Trans>About</Trans>
                      </div>
                      <div>{item.about}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <Footer />
      </div>
    </SEO>
  );
}
